<template>
	<div class="container">
		<!--div class="bc" @keyup.enter="goto"-->
		<div class="bc">
			<!-- <div style="display: none;"> -->

			<div class="left">
				<img src="../assets/imgs/bg_login.jpg" alt="">

			</div>
			<div class="right">
				<section>
					<div class="top">
						<div>
							<img class="topImg" src="../assets/imgs/logo.png" alt="">
						</div>
						<div style="margin-left: 10px;margin-top: 0px;">
							<p class="title">江苏国际人才公寓管理平台</p>
							<p style="font-size: 14px;color: #666666;">JIANGSU INTERNATIONAL TALENT APARTIMENT MANGEMENT
								PLATFORM</p>
						</div>
					</div>

					<div class="topInput">
						<input class="input" type="text" v-model="formData.username" placeholder="账号" >
					</div>
					<div class="topInput">
						<input class="input" type="password" v-model.trim="formData.password" placeholder="密 码"
							:maxlength="8">
					</div>
					<div class="topInput" style="margin: 0 auto;">
						<div style="position: relative;">
							<input class="input" type="text" v-model.trim="formData.code" placeholder="验 证 码"
								:maxlength="8">
							<img :src="imgData" alt="" @click="getCode"
								style="position: absolute;width: 110px;height: 42px;top: 0;right: 30%;">
						</div>
					</div>
					<div class="bottomInput">
						<button class="loginBotton" @click="login">登&nbsp;&nbsp;&nbsp;&nbsp;录</button>
					</div>
					<!-- <div class="forget" @click="forget">忘记密码?</div> -->

					<!-- <div class="bottomInput"> -->

					<!-- </div> -->

				</section>
			</div>
		</div>
		<div class="footer">
			江苏国际人才咨询服务有限公司 版权所有 <a href="https://beian.miit.gov.cn/" target="_blank">苏ICP备2022001462号</a>
		</div>

	</div>
</template>

<script>
import axios from 'axios'
import Cookies from 'js-cookie'
// import JSEncrypt from 'jsencrypt/bin/jsencrypt'
export default {
	data() {
		return {
			formData: {
				code: "",
				uuid: "",
				username: "",
				password: "",
				// type: "web"
			},
			time: "",
			num: 3,
			imgData: null
		};
	},
	methods: {
		getCode() {
			this.$http.get("/api/code").then(res => {
				this.formData.uuid = res.data.uuid;
				this.imgData = "data:image/jpeg;base64," + res.data.img;
			})
		},
		login() {
			if (this.formData.username == 'admin') {
				this.$message.error('非法请求')
				return
			}
			this.$http.post(`/api/auth/login`, this.formData).then(res => {
				if (res.data.code == 500) {
					this.$message.error(res.data.msg)
					this.getCode()
				}
				if (res.data.code == 200) {
					this.$message.success("欢迎登录人才大厦平台")
					localStorage.access_token = res.data.data.access_token
					Cookies.set('Admin-Token', res.data.data.access_token)
					Cookies.set('Admin-Expires-In', res.data.data.expires_in)

					this.$http.get("/api/system/user/getInfo").then(res => {
						console.log('res data:', JSON.stringify(res.data))
						sessionStorage.createId = res.data.user.userId
						localStorage.createId = res.data.user.userId

						sessionStorage.name = res.data.user.userName
						localStorage.name = res.data.user.userName
						localStorage.deptId = res.data.user.deptId
						sessionStorage.roleId = res.data.user.roles[0].roleId
						sessionStorage.roleKey = res.data.user.roles[0].roleKey
						localStorage.roleId = res.data.user.roles[0].roleId
						//localStorage.roleIds = res.data.roleIds
						localStorage.roles = JSON.stringify(res.data.roles)
						localStorage.permissions = JSON.stringify(res.data.permissions)
						//this.store.state.permissions = res.data.permissions;

						// localStorage.role = JSON.stringify(res.data.user.roles[0].roleId) 
						if (localStorage.deptId == 187 || localStorage.deptId == 188) {
							this.$router.push("/index");
							setTimeout(() => {
								this.$router.push("/index/business/businessPlanning")
							}, 1000)
						} else if (localStorage.deptId != 115) {
							this.$router.push("/index");
							setTimeout(() => {
								this.$router.push("/index/console")
							}, 1000)
						}
						else {
							this.$router.push("/index/controller");
						}

					})
					return

					// this.$router.push("/index/console/statistics");
					// if (sessionStorage.roleId == 2) {
					// 	this.$router.push("/index/console/statistics");
					// } else {
					// 	this.$router.push("/index/console/register");
					// }
				}

			})
		},
		forget() {
			this.$router.push("/forget")
		}
	},

	mounted() {
		// Cookies.ro('Admin-Token', res.data.data.access_token)
		// Cookies.set('Admin-Expires-In', res.data.data.expires_in)
		this.getCode()
		sessionStorage.clear()
		localStorage.clear()
		if (sessionStorage.code == 401) {
			this.$message.error("登录过期")
		}
		return
	},
	created() {
		// return
		// let url = window.location.href;
		// sessionStorage.removeItem("token")
		// sessionStorage.removeItem("roleId")
		// this.$http.get("/api/cas/hello").then(res=>{
		// 	console.log(res)
		// })
		//  return


		// if (url.indexOf("ticket=") != -1) {
		// 	console.log("Jinalil")
		// 	this.$http.get("/api/cas/hello").then(res => {
		// 		console.log(res.data)

		// 	})


		// 	window.location.href = "http://192.168.0.122:8008/cas/hello";
		// }
		// this.time = setInterval(() => {
		//  this.$message.success(`${this.num}后自动登录`)
		//  this.num--
		//  if (this.num == 0) {
		//   clearInterval(this.time)
		//   this.goto()
		//  }
		// }, 1000)
	}
}
</script>

<style scoped="scoped">
.container {
	width: 100%;
	height: 100%;
}

.bc {
	width: 100%;
	height: 90%;
	display: flex;
}

.left,
.right {
	width: 50%;
	height: 100%;

}

.left img {
	width: 100%;
	height: 100%;
}

input {
	padding-left: 16px;
}



section {
	margin-left: -10%;
}


.top {
	display: flex;
	justify-content: center;
	margin-top: 25%;
}

.topImg {
	width: 70px;
	height: 70px;
}

.title {
	color: #545B66;
	font-size: 36px;
	letter-spacing: 2px;
}

.loginBotton {
	margin: 0 auto;
	display: block;
	width: 80%;
	height: 45px;
	border: none;
	outline: none;
	text-align: center;
	color: white;
	cursor: pointer;
	background-color: #B4AC8A;
	font-size: large;
}


.input {
	width: 40%;
	margin: 20px auto;
	display: block;
	height: 42px;
	border: none;
	outline: none;
	border-bottom: 1px solid #DCDCDC;
	font-size: larger;
}

.bottomInput {
	width: 50%;
	margin: 0 auto;
}

.forget {
	width: 50%;
	margin: 5px auto;
	display: block;
	cursor: pointer;
	color: #666666;
	padding-left: 55px;
	font-size: 15px;
}

.footer {
	width: 100%;
	height: 40px;
	text-align: center;
	padding-top: 15px;
}
</style>
